import Vue from "vue";
import VueRouter from "vue-router";
import waitFor from "@/utils/waitFor";
import store from "@/store";
import signin from "@/router/reports/signin";
import signout from "@/router/reports/signout";
import version from "@/router/reports/version";
import organizations from "@/router/reports/organizations";
import users from "@/router/reports/users";
import reports from "@/router/reports/reports";
import investigations from "@/router/reports/investigations";
import notFound from "@/router/reports/not-found";
import policies from "@/router/reports/policies";
import admin from "@/router/reports/admin";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/reports/Home.vue"),
    meta: {
      authorization: { policies: ["authenticated"] },
    },
  },
  {
    path: "/help/video/:host/:videoId",
    props: route => ({ host: route.params.host, videoId: route.params.videoId, h: route.query.h }),
    component: () => import("@/views/reports/HelpVideo.vue"),
    meta: {
      authorization: { policies: ["authenticated"] },
    },
  },
  ...signin,
  ...signout,
  ...version,
  ...organizations,
  ...users,
  ...reports,
  ...investigations,
  ...admin,
  ...notFound,
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  // state
  await waitFor(() => store.getters["isInitialized"]);

  if (store.getters["isAuthenticated"]) {
    await waitFor(() => store.getters["user/user"]);
    await waitFor(() => store.getters["organization/organizations"]);
    await waitFor(() => store.getters["role/roles"]);
    await waitFor(() => store.getters["feature/features"]);
  }

  // policies
  policies.run(to, from, next);
});

export default router;
